export default {
  snap: {
    card: "bg-paper border-2 grad_border_4 rounded-2xl p-5 flex flex-col sm:flex-row items-center gap-4",
    icon_wrapper: "w-11 h-11 rounded-xl bg-secondary/80 flex items-center justify-center shrink-0",
    icon: "w-5 h-5 text-white stroke-2",
    info: "flex-1 min-w-0",
    title: "font-semibold text-text text-center sm:text-left truncate",
    description: "text-sm text-text_secondary text-center sm:text-left truncate",
    meta: "text-sm text-text_secondary text-center sm:text-left mt-0.5",
    meta_version: "font-semibold text-text",
    action: "shrink-0 sm:ml-auto",
    button_variant: "primary_m",
    action_link: "inline-flex items-center gap-2 text-sm text-primary font-medium hover:underline",
    changelog_container: "bg-gradient-to-br from-paper/60 via-paper to-paper/80 border-2 border-theme_white rounded-2xl p-5 mt-4",
    changelog_heading: "w-fit text-xs font-semibold uppercase tracking-wider bg-secondary/20 text-text font-bold rounded-full px-3 py-2 mb-4",
    changelog_entries: "space-y-5",
    changelog_version: "font-bold text-text uppercase tracking-wide text-sm",
    changelog_date: "text-xs text-neutral_2",
    changelog_text: "text-sm text-text_secondary leading-relaxed mt-1.5 space-y-1 list-none pl-0",
    changelog_line: "flex items-start gap-2",
    changelog_bullet: "shrink-0 select-none text-text",
  },
}
